import api from '@/api/axiosApi'
import type {
  ConsolidatedDcRead,
  DefaultStrategyGroup,
  MilestoneRead,
  StockingStrategyCodeRead,
} from './clt.types'

export async function listMilestones(): Promise<MilestoneRead[]> {
  const response = await api.get<MilestoneRead[]>('/milestones')
  return response.data
}

export async function listStockingStrategyCodes(): Promise<
  StockingStrategyCodeRead[]
> {
  const response = await api.get<StockingStrategyCodeRead[]>(
    '/stocking-strategy-codes'
  )
  return response.data
}

export async function listDefaultStrategyGroups(): Promise<
  DefaultStrategyGroup[]
> {
  const response = await api.get<DefaultStrategyGroup[]>(
    '/stocking-strategy-codes/default-groups'
  )
  return response.data
}

export async function listConsolidatedDcs(): Promise<ConsolidatedDcRead[]> {
  const response = await api.get<ConsolidatedDcRead[]>('/consolidated-dcs')
  return response.data
}
